import ReactDOM from 'react-dom/client';
import AppRouter from '@/routes';
import { Toaster } from '@leadsnavi/ui-kit';
import { ConfirmProvider } from '@/components/confirm-dialog';
// import { ModalContainer } from '@/components/moda-lInvoker';
import { AUTH_TOKEN_COOKIE_KEY, VISITOR_ID_COOKIE_KEY } from '@/utils/auth';

import '@/i18n';
import './styles/globals.scss';
import './styles/tailwind.css';

// 本地开发环境：从 URL 参数接收 token、visitor_id 并写入 Cookie（始终覆盖，避免旧 token 导致登录态异常）
if (import.meta.env.DEV) {
  const url = new URL(window.location.href);
  const devToken = url.searchParams.get('__dev_token__');
  const devVisitorId = url.searchParams.get('__dev_visitor_id__');

  if (devToken) {
    document.cookie = `${AUTH_TOKEN_COOKIE_KEY}=${encodeURIComponent(devToken)}; path=/`;
  }
  if (devVisitorId) {
    document.cookie = `${VISITOR_ID_COOKIE_KEY}=${encodeURIComponent(devVisitorId)}; path=/`;
  }

  if (devToken || devVisitorId) {
    url.searchParams.delete('__dev_token__');
    url.searchParams.delete('__dev_visitor_id__');
    window.history.replaceState({}, '', url.toString());
  }
}

// 渲染主应用
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <ConfirmProvider>
    <AppRouter />
    {/* <ModalContainer /> */}
    <Toaster />
  </ConfirmProvider>
);

// 开发 / test 环境下动态加载并挂载调试工具
// 生产构建时 process.env.env 被替换为字面量，条件为 false，代码会被 tree-shake
if (import.meta.env.DEV || process.env.env === 'test') {
  import('@/dev-tools').then(({ DevTools }) => {
    const devRoot = document.createElement('div');
    devRoot.id = 'dev-tools-root';
    document.body.appendChild(devRoot);
    ReactDOM.createRoot(devRoot).render(<DevTools />);
  });
}
